import React from "react";

// PLATFORM logo for the app chrome (top nav, login, drawer). The mark is the user-supplied
// transparent icon (sun + solar panel); the wordmark is rendered as TEXT — GRID + FORGE
// (Solar Gold) in Montserrat-900 — so the artwork never carries its own text and the wordmark
// stays legible on any surface. `variant="light"` = white GRID for dark chrome; default = black.
export default function BrandLogo({ variant = "dark", size = 22, className = "" }) {
  const text = variant === "light" ? "text-white" : "text-black";
  const markH = Math.round(size * 2.6);
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src="/gridforge-mark.png"
        alt=""
        aria-hidden="true"
        draggable="false"
        className="block select-none shrink-0"
        style={{ height: `${markH}px`, width: "auto" }}
      />
      <span
        className={`font-display font-black uppercase tracking-tight leading-none ${text}`}
        style={{ fontSize: `${size}px` }}
      >
        GRID<span className="text-[#F4C400]">FORGE</span>
      </span>
    </div>
  );
}
